import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getSessionValue, saveSessionValue } from "../utilities/localStore/calls";
export interface iSiteInfo {
    workflowPoppped: boolean;
    queuesListVisible: boolean;
    enquiriesListVisible: boolean;
    searchResultsVisible: boolean;
    userPreferanceVisible: boolean;
    restrictedView: boolean;
    userProfileVisible: boolean;
    reportsVisible: boolean;
    MISreportsVisible: boolean;
    teamEnquiriesVisible: boolean;
}

const initialState: iSiteInfo = {
    workflowPoppped: false,
    queuesListVisible: false,
    enquiriesListVisible: false,
    restrictedView: false,
    searchResultsVisible: false,
    userPreferanceVisible: false,
    userProfileVisible: false,
    reportsVisible: false,
    MISreportsVisible: false,
    teamEnquiriesVisible: false,
};

const changeState = (state: iSiteInfo): iSiteInfo => {
    state.enquiriesListVisible = false;
    state.queuesListVisible = false;
    state.userPreferanceVisible = false;
    state.searchResultsVisible = false;
    state.userProfileVisible = false;
    state.reportsVisible = false;
    state.MISreportsVisible = false;
    state.teamEnquiriesVisible = false;
    return state;
};

export const SiteSlice = createSlice({
    name: "SiteInformation",
    initialState,
    reducers: {
        setSearchResultsVisibility: state => {
            state = changeState(state);
            state.searchResultsVisible = true;
        },
        setQueuesVisibility: state => {
            state = changeState(state);
            state.queuesListVisible = true;
        },
        setEnquiriesVisibility: state => {
            state = changeState(state);
            state.enquiriesListVisible = true;
        },
        setUserPreferancesVisibility: state => {
            state = changeState(state);
            state.userPreferanceVisible = true;
        },
        setUserProfileVisibility: state => {
            state = changeState(state);
            state.userProfileVisible = true;
        },
        setReportsVisibility: state => {
            state = changeState(state);
            state.reportsVisible = true;
        },
        setMISReportsVisibility: state => {
            state = changeState(state);
            state.MISreportsVisible = true;
        },
        setTeamEnquiriesVisibility: state => {
            state = changeState(state);
            state.teamEnquiriesVisible = true;
        },
        setRestrictedView: (state, action) => {
            state.restrictedView = action.payload;
            if (action.payload == true) {
                if (!getSessionValue<boolean>("ScreenSizeChanged")) {
                    saveSessionValue("ScreenSizeChanged", false);
                } else {
                    saveSessionValue("ScreenSizeChanged", true);
                }
            }
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setQueuesVisibility,
    setEnquiriesVisibility,
    setUserPreferancesVisibility,
    setRestrictedView,
    setSearchResultsVisibility,
    setUserProfileVisibility,
    setReportsVisibility,
    setMISReportsVisibility,
    setTeamEnquiriesVisibility,
} = SiteSlice.actions;

export default SiteSlice;
